var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheilLogoOnDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 51,
    viewBox: "0 0 163 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2377_706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.512 1.63867H149.277V49.3737H162.512V1.63867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.225 14.6772H128.99V49.3736H142.225V14.6772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.99 13.4041V1.63867H142.8L128.99 13.4041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.808 34.4618C101.163 38.7835 103.649 41.734 107.701 41.734C110.382 41.734 112.88 40.3384 113.737 38.3673H125.404C123.115 46.068 115.365 50.3898 107.958 50.3898C96.1926 50.3898 88.1123 43.1053 88.1123 31.5969C88.1123 21.1292 95.6294 12.5959 107.064 12.5959C120.336 12.5959 126.445 21.8393 126.445 31.5969C126.445 32.5641 126.371 33.5313 126.151 34.4618H100.808ZM113.761 27.4343C113.761 24.0308 111.313 21.2639 107.823 21.2639C103.808 21.2639 101.482 23.4676 100.869 27.4343H113.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0876 17.5667C65.5607 15.3507 68.854 13.8081 73.6165 13.8081C80.1298 13.8081 85.9451 17.6157 85.9451 25.5735V49.3737H72.7106V31.193C72.7106 27.1774 71.976 24.3737 68.095 24.3737C65.879 24.3737 63.0754 25.8919 63.0754 31.2542V49.386H49.8408V1.63867H63.0754V17.5667H63.0876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6885 19.4153C32.407 17.6768 30.8399 12.4001 24.3756 12.4001C17.0421 12.4001 14.7037 19.0847 14.7037 25.5C14.7037 31.9153 17.0544 38.5999 24.3756 38.5999C29.6401 38.5999 31.8193 35.1229 32.762 30.642H47.5024C47.5024 40.2649 38.4549 50.5 24.7919 50.5C9.26787 50.5 0 39.6038 0 25.5C0 11.3962 10.1371 0.5 24.7919 0.5C37.1082 0.5 45.9721 7.45397 47.2943 19.4153H32.6885Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2377_706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162.524,
    height: 50,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheilLogoOnDark);
export default __webpack_public_path__ + "static/media/cheil-logo-on-dark.4bfacdfdc7eb162fae755b2ed92d4761.svg";
export { ForwardRef as ReactComponent };